import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-5e9a0c0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bottom-content-image",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Get Started ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("with THE ORCA ")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

import { inject, reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = reactive({
  isTablet: inject('isTablet')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bottom", {tablet: _unref(data).isTablet}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("h3", {
        class: _normalizeClass(["bottom-content-title", {tablet: _unref(data).isTablet}])
      }, _hoisted_6, 2)
    ])
  ], 2))
}
}

})